import { createAction, props } from '@ngrx/store';
import { PaymentFeesMarketPaginableRequestInterface, PaymentMarketPaginableRequestInterface, RateSmallpayMarketPaginableRequestInterface, UpdateDocumentResponse } from 'sp-arch-lib';
import { PaginableInterface, Payment, PaymentFee, PaymentInstallment } from 'sp-ui-lib';

export const resetStore = createAction(
  '[Payments] Reset Payments Store'
);

export const retrievePayments = createAction(
  '[Payments] Retrieve Market Payments',
  props<{ paymentRequestInterface: PaymentMarketPaginableRequestInterface }>()
);

export const retrievePaymentSuccess = createAction(
  '[Payments] Retrieve Market Payment Success',
  props<{ payments: PaginableInterface<Payment> }>()
);

export const retrievePaymentFailure = createAction(
  '[Payments] Retrieve Market Payment Failure'
);

export const retrievePaymentInstallments = createAction(
  '[Payments] Retrieve Market Payment Services',
  props<{ rateSmallpayMarketPaginableRequestInterface: RateSmallpayMarketPaginableRequestInterface }>()
);

export const retrievePaymentInstallmentsSuccess = createAction(
  '[Payments] Retrieve Market Payment Service Success',
  props<{ paymentServices: PaginableInterface<PaymentInstallment> }>()
);

export const retrievePaymentInstallmentsFailure = createAction(
  '[Payments] Retrieve Market Payment Service Failure'
);

export const retrieveCurrentPayment = createAction(
  '[Payments] Market Retrieve Current Payment',
  props<{ id: number }>()
);

export const retrieveCurrentPaymentSuccess = createAction(
  '[Payments] Market Retrieve Current Payment Success',
  props<{ payment: Payment }>()
);

export const retrieveCurrentPaymentFailure = createAction(
  '[Payments] Market Retrieve Current Payment Failure'
);

export const retrievePaymentFees = createAction(
  '[Payments] Market Retrieve Payment Fees',
  props<{ paymentFeesRequestInterface: PaymentFeesMarketPaginableRequestInterface }>()
);

export const retrievePaymentFeesSuccess = createAction(
  '[Payments] Market Retrieve Payment Fees Success',
  props<{ fees: PaginableInterface<PaymentFee> }>()
);

export const retrievePaymentFeesFailure = createAction(
  '[Payments] Market Retrieve Payment Fees Failure'
);

export const downloadDocument = createAction(
  '[Payments] Download Document',
  props<{ paymentId: number }>()
);

export const downloadDocumentSuccess = createAction(
  '[Payments] Download Document Success',
  props<{ document: UpdateDocumentResponse }>()
);

export const downloadDocumentFailure = createAction(
  '[Payments] Download Document Failure'
);

export const openDocument = createAction(
  '[Payments] Open Document',
  props<{ document: UpdateDocumentResponse }>()
);
